/**
 * @module AuthApi
 *  Apis must need auth details to trigger url - AuthApi
 */
/* eslint-disable */

import axios from 'axios';
import store from '@/store/store';
import Env from '@/env';

export default {
    /**
     * Create Custom Api
     * @function
     * @param {string} url - Url to get results
     * @returns {object} A promise that will return either a success object or an error object.
     */
    customApi: (method, url, headers) => {
        return axios({
            method,
            url,
            headers,
        });
    },

    /**
     * Call to an GET Authenticate api for response.
     * @function
     * @param {string} url - Url to get results
     * @returns {object} A promise that will return either a success object or an error object.
     */
    getApi: (url, header) => {
        return axios({
            method: 'GET',
            url,
            headers: header ? header : {
                'api-token': Env.apiToken,
                'auth-token': store.getters.getLoggedInUserToken,
            },
        });
    },

    /**
     * Call to an POST Authenticate api for response.
     * @function
     * @param {string} url - Url to get results
     * @param {string} data - accept objects
     * @returns {object} A promise that will return either a success object or an error object.
     */
    postApi: (url, header, data) => {
        return axios({
            method: 'POST',
            url,
            headers: header ? header : {
                'api-token': Env.apiToken,
                'auth-token': store.getters.getLoggedInUserToken,
            },
            data,
        });
    },

    /**
     * Call to an PUT Authenticate api for response.
     * @function
     * @param {string} url - Url to get results
     * @param {string} data - accept objects
     * @returns {object} A promise that will return either a success object or an error object.
     */
    putApi: (url, header, data) => {
        return axios({
            method: 'PUT',
            url,
            headers: header ? header : {
                'api-token': Env.apiToken,
                'auth-token': store.getters.getLoggedInUserToken,
            },
            data,
        });
    },

    /**
     * Call to an PATCH Authenticate api for response.
     * @function
     * @param {string} url - Url to get results
     * @param {string} data - accept objects
     * @returns {object} A promise that will return either a success object or an error object.
     */
    patchApi: (url, header, data) => {
        return axios({
            method: 'PATCH',
            url,
            headers: header ? header : {
                'api-token': Env.apiToken,
                'auth-token': store.getters.getLoggedInUserToken,
            },
            data,
        });
    },
    /**
     * Call to an DELETE Authenticate api for response.
     * @function
     * @param {string} url - Url to get results
     * @returns {object} A promise that will return either a success object or an error object.
     */
    deleteApi: (url, header, data = {}) => {
        return axios({
            method: 'DELETE',
            url,
            headers: header ? header : {
                'api-token': Env.apiToken,
                'auth-token': store.getters.getLoggedInUserToken,
            },
            data
        });
    },

    /**
     * Call to select user account
     * @function
     * @param {id} url - numeric
     * @returns {object} A promise that will return  boolean
     */
    setActiveBusiness(id) {
        // Incase blank accountId passed, prevent
        if (!id) {
            return false;
        }
        // Trigger api to get session
        const url = `${Env.url}/api/v1/users/businesses/${id}`;
        return this.patchApi(url)
            .then((res) => {
                // Save in store select account details
                store.dispatch('SET_USER_SELECTED_ACCOUNT', res.data.payload);
                return true;
            })
            .catch(() => false);
    },

    /**
     * this api just check whether the token is valid or not
     * @returns (boolean) true of false depending on the bearer token set
     */
    isValidToken(userToken) {
        const url = `${Env.url}/api/v1/users/auth/verify`;
        return this.customApi('GET', url, {
                'api-token': Env.apiToken,
                'auth-token': userToken ? userToken : store.getters.getLoggedInUserToken,
            }, )
            .then(() => {
                return true;
            })
            .catch(() => false);
    },
};